module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-03.884f07f1.png";